import { combineReducers } from 'redux';
import markets from './marketsReducer';
import slip from './slipReducer';
import app from './appReducer';
import auth from './authReducer';
const BYOReducer = combineReducers({
    markets,
    slip,
    app,
    auth,
});
export default BYOReducer;
